// Panier catalogue (Lot D) — « commande en cours » construite depuis le catalogue.
//
// Des lignes (une paire = une variante + sa taille + son prix) sont tenues en
// localStorage pendant que l'utilisateur parcourt le catalogue visuel, puis
// transformées en une vraie commande (POST commandePost + detail-commande).
//
// ⚠ N'INTERAGIT PAS avec le stock : le stock ne baisse qu'à la vente confirmée.
// Le panier n'est qu'une intention de commande (comme le formulaire desktop).

const KEY = 'ndoe_panier_catalogue';

const read = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(raw) ? raw : [];
  } catch (e) {
    return [];
  }
};

const listeners = new Set();
const emit = (lines) => listeners.forEach((fn) => { try { fn(lines); } catch (e) { /* isolé */ } });

const write = (lines) => {
  localStorage.setItem(KEY, JSON.stringify(lines));
  emit(lines);
};

export const getPanier = () => read();

// S'abonner aux changements (dans le même onglet). Retourne une fonction de désabonnement.
export const subscribe = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const clearPanier = () => write([]);

export const removeLine = (idVariante) =>
  write(read().filter((l) => l.id_varianteProduit !== idVariante));

export const setQte = (idVariante, qte) =>
  write(read().map((l) => (l.id_varianteProduit === idVariante ? { ...l, qte: Math.max(1, Number(qte) || 1) } : l)));

// Ajoute une paire (ou incrémente sa quantité si déjà présente). Retourne le panier à jour.
export const addToPanier = (line) => {
  const lines = read();
  const i = lines.findIndex((l) => l.id_varianteProduit === line.id_varianteProduit);
  const qte = Math.max(1, Number(line.qte) || 1);
  if (i >= 0) lines[i] = { ...lines[i], qte: (Number(lines[i].qte) || 1) + qte };
  else lines.push({ ...line, qte });
  write(lines);
  return lines;
};

export const panierTotal = (lines) =>
  (lines || read()).reduce((sum, l) => sum + (Number(l.prix) || 0) * (Number(l.qte) || 1), 0);

export const panierCount = (lines) =>
  (lines || read()).reduce((sum, l) => sum + (Number(l.qte) || 1), 0);
